import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ReportPrintingModalState {
    isReportModalOpen: boolean;
}

type StateWithReportPrintingModal = { reportPrintingModal: ReportPrintingModalState };

const initialState: ReportPrintingModalState = {
    isReportModalOpen: false,
};

const reportPrintingModalSlice = createSlice({
    name: 'reportPrintingModal',
    initialState,

    reducers: (create) => ({
        setReportModalOpen: create.reducer((state, action: PayloadAction<boolean>) => {
            state.isReportModalOpen = action.payload;
        })
    })
});

// eslint-disable-next-line no-restricted-syntax
export default reportPrintingModalSlice.reducer;
export const selectIsReportModalOpen = (state: StateWithReportPrintingModal) => state.reportPrintingModal.isReportModalOpen;
export const { setReportModalOpen } = reportPrintingModalSlice.actions;
